//#region src/core/errors.ts
var e = class extends Error {
	code;
	status;
	traceId;
	retryable;
	details;
	constructor(e, t, n = {}) {
		super(t, { cause: n.cause }), this.name = "PlatformSdkError", this.code = e, this.status = n.status, this.traceId = n.traceId, this.retryable = n.retryable ?? !1, this.details = o(n.details);
	}
}, t = Object.freeze({
	HOST_UNAVAILABLE: "当前应用不支持表单会话",
	PROTOCOL_UNSUPPORTED: "表单会话协议不受支持",
	CAPABILITY_INVALID: "表单会话能力不完整或非法",
	RECEIVER_DUPLICATE: "表单会话接收器已登记",
	INPUT_INVALID: "表单会话输入不完整或不匹配",
	STALE: "表单会话已失效",
	BRIDGE_DUPLICATE: "当前表单已登记操作能力",
	CAPABILITY_MISMATCH: "表单用途与操作能力不匹配",
	NOT_READY: "表单会话尚未就绪",
	UPDATE_INVALID: "表单版本更新不合法",
	APPLY_FAILED: "表单输入与路由提交失败",
	OPEN_TIMEOUT: "表单会话打开超时",
	CLOSE_TIMEOUT: "表单会话清理未完成",
	UPDATE_TIMEOUT: "表单保存成功，但版本更新未完成，请重新加载"
});
function n(n, r) {
	return new e(`SDK_FORM_SESSION_${n}`, t[n], { cause: r });
}
var r = Object.freeze({
	PORTAL_FORM_SESSION_SWITCH_BUSY: "表单正在保存或结果尚未确认，请稍后重试",
	PORTAL_FORM_SESSION_LEAVE_CHANGED: "当前离开请求已取消或表单状态已变化",
	PORTAL_FORM_RUNTIME_RECLAIM_BLOCKED: "应用表单运行时尚未回收，请稍后重试"
});
function i(t, n) {
	return new e(t, r[t], { cause: n });
}
var a = /(authorization|cookie|token|password|secret|credential|private.?key|payload)/i;
function o(e) {
	return e ? Object.freeze(Object.fromEntries(Object.entries(e).filter(([e]) => !a.test(e)).map(([e, t]) => [e, s(t)]))) : {};
}
function s(e) {
	return Array.isArray(e) ? e.slice(0, 20).map(s) : e && typeof e == "object" ? o(e) : typeof e == "string" && e.length > 512 ? `${e.slice(0, 512)}…` : e;
}
function c(t, n) {
	let r = n && typeof n == "object" ? n : {};
	return new e(typeof r.code == "string" ? r.code : "SDK_HTTP_ERROR", typeof r.message == "string" ? r.message : `请求失败（HTTP ${t.status}）`, {
		status: t.status,
		traceId: typeof r.traceId == "string" ? r.traceId : void 0,
		retryable: r.retryable === !0,
		details: r.details && typeof r.details == "object" && !Array.isArray(r.details) ? r.details : void 0
	});
}
//#endregion
export { i as a, n as i, r as n, o, e as r, c as s, t };
